var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClassVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 23,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.15 20.17C34.74 19.95 33.88 19.72 32.71 20.54L31.24 21.58C31.13 18.47 29.78 17.25 26.5 17.25H20.5C17.08 17.25 15.75 18.58 15.75 22V30C15.75 32.3 17 34.75 20.5 34.75H26.5C29.78 34.75 31.13 33.53 31.24 30.42L32.71 31.46C33.33 31.9 33.87 32.04 34.3 32.04C34.67 32.04 34.96 31.93 35.15 31.83C35.56 31.62 36.25 31.05 36.25 29.62V22.38C36.25 20.95 35.56 20.38 35.15 20.17ZM25 25.38C23.97 25.38 23.12 24.54 23.12 23.5C23.12 22.46 23.97 21.62 25 21.62C26.03 21.62 26.88 22.46 26.88 23.5C26.88 24.54 26.03 25.38 25 25.38Z",
    fill: "#017EA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassVideoIcon);
export default __webpack_public_path__ + "static/media/classVideoIcon.d70bebeeccbdeda9ea62121b20385025.svg";
export { ForwardRef as ReactComponent };